import {useEntityIntegrationsQuery} from '../../generated/graphql';
import {isSlackIntegration} from '../SlackIntegration/utils';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {
  EntityIntegrations,
  Integration,
} from './ArtifactCollectionNotifications';

export const useEntityIntegrations = (
  entityName: string
): EntityIntegrations => {
  const {data, loading, error, refetch} = useEntityIntegrationsQuery({
    variables: {
      name: entityName,
    },
    fetchPolicy: 'network-only',
  });
  if (loading || !data || !data.entity || error) {
    return {
      loading,
      refetch,
      entityName: '',
      data: [],
    };
  }
  const edges = data.entity.integrations?.edges ?? [];
  const integrations = edges
    .map((e: any) => e.node)
    .filter((n: any) => !!n)
    .filter((n: any) => isSlackIntegration(n as any))
    .map((n: any) => {
      const node = n as any;
      return {
        id: node.id,
        type: 'slack',
        teamName: node.teamName,
        channelName: node.channelName,
      } as Integration;
    });

  return {
    loading,
    refetch,
    entityName: data.entity.name,
    data: integrations,
  };
};
